@if (doingBulkAction) {
  <div class="shade-host">
    <div #shade class="shade-bkgd"></div>
  </div>
}

<div
  class="bulk-action-tool"
  [class.open]="doingBulkAction"
>
  @if (!doingBulkAction) {
    <div
      class="title"
    >
      <div
        class="info"
      >
        <i class="fa-regular fa-circle-check"></i>
        {{selectedValues.length}} item{{selectedValues.length === 1 ? '' : 's'}} selected
      </div>

      <div
        class="buttons"
      >
        @if (capabilities?.configureTiles && isBulkConfigurationEnabled) {
          <button
            class="small"
            [class.inactive]="cannotConfigureSelectedTiles()"
            (click)="startConfigureTiles()"
          >
            Bulk Configure
          </button>
        }

        @if (capabilities?.downloadConfiguration && isBulkConfigurationEnabled) {
          <button
            class="small"
            [class.inactive]="cannotDownloadConfigurationForSelectedTiles()"
            (click)="startDownloadConfiguration()"
          >
            Download Configuration CSV
          </button>
        }

        @if (capabilities?.cloneTiles) {
          <button
            class="small"
            [class.inactive]="cannotCloneSelectedTiles()"
            (click)="startCloneTiles()"
          >
            Clone Tiles
          </button>
        }

        @if (capabilities?.deleteTiles) {
          <button
            class="small red"
            [class.inactive]="selectedValues.length === 0"
            (click)="startDeleteTiles()"
          >
            Delete Tiles
          </button>
        }

        <button
          class="small alt"
          (click)="cancel()"
        >
          Cancel Bulk Select
        </button>
      </div>
    </div>
  }

  @if (doingCloneTiles) {
    <div
      class="title"
    >
      <div
        class="info"
      >
        <i class="fa-regular fa-clone"></i>
        Cloning {{selectedValues.length}} Tile{{selectedValues.length === 1 ? '' : 's'}}
      </div>

      <div
        class="buttons"
      >
        <button
          class="small alt"
          (click)="doingCloneTiles = false"
        >
          Cancel
        </button>
      </div>
    </div>

    <motn-bulk-clone-tiles
      [tiles]="tiles"
      [devices]="devices"
      (done$)="closeOpenTools()"
    ></motn-bulk-clone-tiles>
  }
</div>
